export default {
  title: 'Datos bancarios',
  sections: {
    personal_info: 'Información personal',
    address: 'Dirección',
  },
  labels: {
    account_number: 'Número de cuenta',
    routing_number: 'Número de ruta',
    email: 'Correo electrónico',
    full_name: 'Nombre completo',
    street: 'Dirección',
    zip_code: 'Código postal',
    city: 'Ciudad',
  },
  tooltip: '¡{{field}} copiado al portapapeles!',
};
